import * as React from 'react';
import { Icon } from '../../../Images';
import { ConfigurationModel } from 'franke-trough-dependencies';

import { Link } from 'react-router-dom';

import './ListItem.scss';
import ConfigurationListItemDetail from './ListItemDetail';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ListItem.messages';
import { formatMessage, GlobalPrivateState } from 'src/api';
import { createApiUrl, appSettings } from 'src/config';
import { userIsInternal, userIsExternal, userIsSalesRep } from 'src/app/Partials/Admin/utils';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { connect } from 'react-redux';

export interface ConfigurationListItemProps {
  configuration: ConfigurationModel;
  authenticator: GlobalPrivateState['authenticator'];
  configurations: GlobalPrivateState['configurations'];
  user: GlobalPrivateState['user'];
  groups: GlobalPrivateState['groups'];
  userData: GlobalPrivateState['userData'];
  dispatch: Function;
  canMoveFolder: boolean;
}

export interface ConfigurationListItemState {
  currentPane: 'default' | 'settings' | 'pdfs' | 'folders' | 'sections';
  folderPath: Array<{ id: string, name: string }>;
}

export class ConfigurationListItemPartial extends React.Component<ConfigurationListItemProps, ConfigurationListItemState> {
  constructor(props: ConfigurationListItemProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      currentPane: 'default',
      folderPath: []
    };
  }

  public render() {
    const { configuration, user, authenticator, userData, groups, configurations, canMoveFolder } = this.props;
    const { currentPane, folderPath } = this.state;

    const isInternalUser = userIsInternal(user.result);
    const isSalesRepUser = userIsSalesRep(user.result);
    const accessToken = authenticator.accessToken && authenticator.accessToken.id;
    const apiUrl = createApiUrl(appSettings.config);
    const isArchived = userData.result && userData.result.archivedConfigurations && userData.result.archivedConfigurations.includes(configuration.id) || false;

    const isExternal = userIsExternal(user.result);
    const troughFilename = configuration && configuration.selectedTrough && configuration.selectedTrough.trough.fileName;

    const groupsArray = groups && groups.result && Array.isArray(groups.result) && groups.result;
    //  ${showSettings ? 'show-settings' : ''}

    return (
      <div className={`partial-configuration-list-item w-100 p-4 page-${currentPane}`}>
        <div className="square-toggle position-absolute" title={formatMessage({...MESSAGES.listItemLinkTitle})}
          onClick={(e) => {
            e.preventDefault();
            if (currentPane === 'default') {
              this.setState({currentPane: 'settings'})
            } else if (currentPane === 'settings') {
              this.setState({currentPane: 'default'})
            } else if (currentPane === 'folders' && folderPath.length > 0) {
              this.navigateUp();
            } else {
              this.setState({currentPane: 'settings'})
            }
          }}>
          {currentPane === 'default' ? (
            <Icon name="settings" size="small" />
          ) : currentPane === 'settings' ? (
            <Icon name="close" size="small" />
          ) : (
            <>
              <Icon name="chevron-left" size="small" /><FormattedMessage {...MESSAGES.listItemGoBack} />
            </>
          )}
        </div>
        <div className="square square-configuration w-100 h-100 d-flex flex-wrap">
          <div className="square-inner inner">
            {currentPane === 'default' && (
              <ConfigurationListItemDetail configuration={configuration} />
            )}
            {currentPane === 'settings' && (
              <div className="square-inner edit-icons">
                {!isExternal && canMoveFolder && (
                  <a href="#folders" onClick={(e) => {
                    e.preventDefault();
                    this.setState({currentPane: 'folders'})
                  }}>
                    <Icon name="box" size="small" />
                    <FormattedMessage {...MESSAGES.listItemMoveToGroup} />
                    <Icon name="chevron-right" size="small" />
                  </a>
                )}
                <Link to={`/configuration/${configuration.id}/duplicate`}>
                  <Icon name="duplicate" size="small" />
                  <FormattedMessage {...MESSAGES.listItemDuplicate} />
                </Link>
                {(configuration.completionStatus === 'draft' || (userData.result && userData.result.labour)) && (
                  <Link to={`/configuration/${configuration.id}/rename`}>
                    <Icon name="rename" size="small" />
                    <FormattedMessage {...MESSAGES.listItemRename} />
                  </Link>
                )}
                {configuration.completionStatus === 'draft' && (
                  <Link to={`/configuration/${configuration.id}/delete`}>
                    <Icon name="delete" size="small" />
                    <FormattedMessage {...MESSAGES.listItemDelete} />
                  </Link>
                )}
                {!isArchived && (
                  <Link to={`/configuration/${configuration.id}/archive`}>
                    <Icon name="archive" size="small" />
                    <FormattedMessage {...MESSAGES.listItemArchive} />
                  </Link>
                )}
                {isArchived && (
                  <Link to={`/configuration/${configuration.id}/unarchive`}>
                    <Icon name="archive" size="small" />
                    <FormattedMessage {...MESSAGES.listItemUnarchive} />
                  </Link>
                )}
                {configuration.completionStatus !== 'draft' && configuration.completionStatus !== 'failed' && configuration.completionStatus !== 'queued' && (
                  <a href="#pdfs" onClick={(e) => {
                    e.preventDefault();
                    this.setState({currentPane: 'pdfs'})
                  }}>
                    <Icon name="pdf" size="small" />
                    <FormattedMessage {...MESSAGES.listItemDownloadPdfs} />
                    <Icon name="chevron-right" size="small" />
                  </a>
                )}
                {(configuration.assemblyAccessories && (configuration.completionStatus === 'draft' || ((isInternalUser || isSalesRepUser) && (configuration.completionStatus !== 'order' && configuration.completionStatus !== 'queued')))) && (
                  <Link to={`/configuration/${configuration.id}/checkout`}>
                    <Icon name="box" size="small" />
                    <FormattedMessage {...MESSAGES.listItemMakeOrder} />
                  </Link>
                )}
              </div>
            )}
            {currentPane === 'pdfs' && (
              <div className="square-inner edit-icons">
                <a href={`${apiUrl}/Orders/${configuration.orderId}/configurationpdf?access_token=${accessToken}`} target="_blank">
                  <Icon name="pdf" size="small" />
                  <FormattedMessage {...MESSAGES.listItemOrderPdf} />
                </a>
                <a href={`${apiUrl}/Configurations/${configuration.id}/manufacturingpdf?access_token=${accessToken}`} target="_blank">
                  <Icon name="pdf" size="small" />
                  <FormattedMessage {...MESSAGES.listItemManufacturingPdf} />
                </a>
                <a href={`https://kwcws3d.blob.core.windows.net/cdn/technical-drawings/${troughFilename}.pdf`} target="_blank">
                  <Icon name="pdf" size="small" />
                  <FormattedMessage {...MESSAGES.listItemTroughPdf} />
                </a>
              </div>
            )}
            {currentPane === 'folders' && (
              <div className="square-inner edit-icons">
                {folderPath.length === 0 && configuration.folderId && (
                  <a href="#move" onClick={(e) => {
                    e.preventDefault();
                    this.moveToFolder(null);
                  }}>
                    <Icon name="folder" size="small" />
                    <FormattedMessage {...MESSAGES.listItemMoveToDashboard} />
                  </a>
                )}

                {folderPath.length > 0 && (
                  <a href="#move" onClick={(e) => {
                    e.preventDefault();
                    this.moveToFolder(folderPath[folderPath.length - 1].id);
                  }}>
                    <Icon name="folder" size="small" />
                    <FormattedMessage {...MESSAGES.listItemMoveToThisGroup} />
                  </a>
                )}

                {groupsArray && groupsArray
                  .filter(group => 
                    folderPath.length === 0 ? !group.parentId : group.parentId === folderPath[folderPath.length - 1].id
                  )
                  .map((group, index) => {
                    const key = `group_list_item_${index}`;
                    const hasChildren = groupsArray.filter(g => g.parentId === group.id).length > 0;

                    return (
                      <a key={key} href="#folder" onClick={(e) => {
                        e.preventDefault();

                        if (hasChildren) {
                          this.navigateToFolder({ id: group.id, name: group.name });
                        } else {
                          this.moveToFolder(group.id);
                        }
                      }}>
                        <Icon name="folder" size="small" />
                        <span>{group.name}</span>
                        {hasChildren && (
                          <Icon name="chevron-right" size="small" />
                        )}
                      </a>
                    );
                  })
                }
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private handleClick(event: React.MouseEvent) {
    event.preventDefault();
  }

  private navigateToFolder = (folder: { id: string, name: string }) => {
    this.setState((prevState) => ({
      folderPath: [...prevState.folderPath, folder]
    }));
  }

  // Go back to the parent folder
  private navigateUp = () => {
    this.setState((prevState) => ({
      folderPath: prevState.folderPath.slice(0, -1)
    }));
  }

  private moveToFolder = async (folderId: string | null) => {
    const { configuration, configurations, dispatch, authenticator, groups } = this.props;
    const accessToken = authenticator.accessToken && authenticator.accessToken.id;

    if (!accessToken) return;

    // Optimistically update the state
    const configurationsBefore = { ...configurations.result } || { rows: [] };
    const updatedConfigurations = { ...configurationsBefore, rows: (configurationsBefore.rows || []).filter(c => c.id !== configuration.id) };

    // Have to also update group/s... find the group.id that matches the folderId, and update it's count... 
    // If it already has a folder ID, it has to decrement a count as well...

    dispatch(requestAPIActions.loadPlain(
      'configurations',
      updatedConfigurations
    ));

    // Make the API request
    const apiUrl = createApiUrl(appSettings.config);
    try {
      const response = await fetch(`${apiUrl}/Configurations/${configuration.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': accessToken
        },
        body: JSON.stringify({ folderId }),
      });

      if (!response.ok) {
        throw new Error('Failed');
      } else {
        this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
          'groups', {
            url: `/Groups/my-groups`
          },
          true
        ));
      }
    } catch (error) {
      // Rollback
      dispatch(requestAPIActions.loadPlain(
        'configurations',
        configurationsBefore
      ));
      // TODO: Error feedback
    }
  }
}

export const ConfigurationListItem = connect((state: GlobalPrivateState) => ({
  configurations: state.configurations,
  authenticator: state.authenticator,
  user: state.user,
  groups: state.groups,
  userData: state.userData,
}))(ConfigurationListItemPartial);

export default ConfigurationListItem;